import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from '@RankHR/Regions/queries-core'
export function useIndividualReportQueryV1(personId?: string | Ref<string>, votingCycle?: string | Ref<string>, ) {
	const _personId = isRef<string>(personId) ? personId : ref<string>(personId)
	const _votingCycle = isRef<string>(votingCycle) ? votingCycle : ref<string>(votingCycle)
	const result = {
		personId: _personId,
		votingCycle: _votingCycle,
		...useQuery(() => new q.IndividualReportQueryV1(_personId.value, _votingCycle.value))
	}
	return {
		...result,
		runIndividualReportQueryV1: result.run,
		modelIndividualReportQueryV1: result.model,
	}
}

export function useOverallReportQueryV1(regionId?: string | Ref<string>, ) {
	const _regionId = isRef<string>(regionId) ? regionId : ref<string>(regionId)
	const result = {
		regionId: _regionId,
		...useQuery(() => new q.OverallReportQueryV1(_regionId.value))
	}
	return {
		...result,
		runOverallReportQueryV1: result.run,
		modelOverallReportQueryV1: result.model,
	}
}

export function useRegionQueryV1(regionId?: string | Ref<string>, ) {
	const _regionId = isRef<string>(regionId) ? regionId : ref<string>(regionId)
	const result = {
		regionId: _regionId,
		...useQuery(() => new q.RegionQueryV1(_regionId.value))
	}
	return {
		...result,
		runRegionQueryV1: result.run,
		modelRegionQueryV1: result.model,
	}
}

export function useSurveyByPersonQueryV1(personId?: string | Ref<string>, ) {
	const _personId = isRef<string>(personId) ? personId : ref<string>(personId)
	const result = {
		personId: _personId,
		...useQuery(() => new q.SurveyByPersonQueryV1(_personId.value))
	}
	return {
		...result,
		runSurveyByPersonQueryV1: result.run,
		modelSurveyByPersonQueryV1: result.model,
	}
}

export function useVotingProgressQueryV1(regionId?: string | Ref<string>, ) {
	const _regionId = isRef<string>(regionId) ? regionId : ref<string>(regionId)
	const result = {
		regionId: _regionId,
		...useQuery(() => new q.VotingProgressQueryV1(_regionId.value))
	}
	return {
		...result,
		runVotingProgressQueryV1: result.run,
		modelVotingProgressQueryV1: result.model,
	}
}

